'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  // Put global functions, jQuery plugins, settings and other useful utility type scripts here
  // namespace them to `window.uomedia` when appropriate
  window.uomedia = window.uomedia || {};
  window.uomedia.ajax_url = $('body').data('ajaxUrl');
  window.uomedia.decodeHtml = (html) => {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  window.uomedia.getCurrentSearchFilter = () => {
    var filter = $('.search-filters a.selected').attr('href').split('#')[1];
    return filter;
  };

  window.uomedia.displayPost = (postType) => {
    const filter = window.uomedia.getCurrentSearchFilter();
    const display = filter === 'all' || postType === filter ? 'block' : 'none';
    return display;
  };

  window.uomedia.getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === variable) { return pair[1]; }
    }
    return (false);
  };

  window.uomedia.constructParkLocationString = (park_locations) => {
    const parkNames = park_locations.map(location => location.name);
    return parkNames.length > 1 ? parkNames.join(' & ') : parkNames[0];
  };

  // see https://spin.js.org/
  window.uomedia.spinnerSettings = {
    lines: 13, // The number of lines to draw
    length: 0, // The length of each line
    width: 14, // The line thickness
    radius: 25, // The radius of the inner circle
    scale: 0.9, // Scales overall size of the spinner
    corners: 1, // Corner roundness (0..1)
    speed: 0.6, // Rounds per second
    rotate: 0, // The rotation offset
    animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: '#ffffff', // CSS color or array of colors
    fadeColor: 'transparent', // CSS color or array of colors
    top: '50%', // Top position relative to parent
    left: '50%', // Left position relative to parent
    shadow: '0 0 1px transparent', // Box-shadow for the lines
    zIndex: 2000000000, // The z-index (defaults to 2e9)
    className: 'spinner', // The CSS class to assign to the spinner
    position: 'absolute', // Element positioning
  };

})(jQuery);
